import { postCreatePaymentSystem } from '../api/postCreatePaymentSystem';

const setPostCreatePaymentSystem = (params ) => {
    return async (dispatch, getState) => {
        try {
            await postCreatePaymentSystem(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreatePaymentSystem
}